// Select list rows wrap the warehouse item in `item`; search rows are the item.
const getWarehouseItemFromRow = values => values?.item ?? values;

const formatWarehouseItemDimensions = ({ dimh, dimw, dimd } = {}) => {
  const dimensions = [
    [dimh, "L"],
    [dimw, "W"],
    [dimd, "H"],
  ];
  if (dimensions.every(([value]) => value == null)) return "";

  return dimensions.map(([value, suffix]) => `${value ?? "-"}${suffix}`).join(" ");
};

export { formatWarehouseItemDimensions, getWarehouseItemFromRow };
